import { BaseCommand } from "./baseCommand";
import { ConfigurationSearch } from "../../entities/configurationSearch";

export class SavedSearchCommand extends BaseCommand {

  getAll?: boolean;
  delete?: number;
  save?: ConfigurationSearch;
}